import { produce } from 'immer';
import { EXECUTE_DATASET_QUERY } from 'app/store/snowflakeQueries/types.js';
import { FetchStatus } from 'app/lib/constants';
import {
    LOAD_COLUMN_STATISTICS,
    CANCEL_COLUMN_STATISTICS,
    LOAD_VIEW_CARDINALITY
} from './types.js';
import { transformColumnStats } from './transformers.js';

function ensureObjectExists(root, property) {
    if (!root.hasOwnProperty(property)) {
        root[property] = {};
    }
}

export const INITIAL_STATE = {
    statusByEntityId: {},
    metricsByEntityId: {},
    requestsByEntityId: {},
    loadingCardinality: false,
    cardinalityByEntityId: {}
};

export const columnStatisticsReducer = produce((draft, action) => {
    switch (action.type) {
        case LOAD_COLUMN_STATISTICS.STARTED: {
            const { entityId, columnName, requestId } = action.meta;
            ensureObjectExists(draft.statusByEntityId, entityId);
            ensureObjectExists(draft.metricsByEntityId, entityId);
            ensureObjectExists(draft.requestsByEntityId, entityId);
            draft.statusByEntityId[entityId][columnName] = FetchStatus.FETCHING;
            draft.requestsByEntityId[entityId][columnName] = requestId;
            delete draft.metricsByEntityId[entityId]?.[columnName];
            break;
        }
        case LOAD_COLUMN_STATISTICS.SUCCEEDED: {
            const { entityId } = action.meta;
            const { metrics } = action.payload;
            const columnName = metrics.name;
            draft.metricsByEntityId[entityId][columnName] = transformColumnStats(metrics);
            draft.statusByEntityId[entityId][columnName] = FetchStatus.SUCCEEDED;
            delete draft.requestsByEntityId[entityId]?.[columnName];
            break;
        }
        case CANCEL_COLUMN_STATISTICS.STARTED:
        case LOAD_COLUMN_STATISTICS.CANCELED: {
            const { entityId, columnName } = action.meta;
            delete draft.requestsByEntityId[entityId]?.[columnName];
            delete draft.statusByEntityId[entityId]?.[columnName];
            break;
        }
        case LOAD_COLUMN_STATISTICS.FAILED:
        case LOAD_COLUMN_STATISTICS.TIMEDOUT: {
            const { entityId, columnName } = action.meta;
            draft.statusByEntityId[entityId][columnName] = FetchStatus.FAILED;
            delete draft.requestsByEntityId[entityId]?.[columnName];
            break;
        }

        case LOAD_VIEW_CARDINALITY.STARTED: {
            draft.loadingCardinality = true;
            break;
        }
        case LOAD_VIEW_CARDINALITY.SUCCEEDED: {
            const { payload } = action;
            const { cardinality, viewUuid } = payload;
            draft.cardinalityByEntityId[viewUuid] = cardinality;
            break;
        }
        case LOAD_VIEW_CARDINALITY.ENDED: {
            draft.loadingCardinality = false;
            break;
        }
        case EXECUTE_DATASET_QUERY.STARTED: {
            const { viewUuid } = action.payload;
            delete draft.statusByEntityId[viewUuid];
            delete draft.metricsByEntityId[viewUuid];
            delete draft.cardinalityByEntityId[viewUuid];
            break;
        }

        default:
            break;
    }
}, INITIAL_STATE);
